module.exports = __webpack_public_path__ + "img/background-day.66da0542.png";